import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/app/_components/ui/sidebar';
import {
  Activity,
  Banana,
  BookOpen,
  Boxes,
  CreditCard,
  Key,
  PlayCircle,
  MessageSquare,
  // ScrollText,
} from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { SidebarMenuItemLink } from './sidebar-menu-item-link';
import { StudioMenuCollapsible } from './studio-menu-collapsible';

const NANO_BANANA_URL =
  import.meta.env.DEV ?
    'http://nanobanana.localhost:3000'
  : import.meta.env.VITE_APP_NANOBANANA_URL ||
    'https://nanobanana.maiarouter.ai';

const items = [
  { title: 'Usage', href: '/dashboard/usage', icon: Activity },
  { title: 'Quick Start', href: '/dashboard/quickstart', icon: BookOpen },
  { title: 'Playground', href: '/dashboard/playground', icon: PlayCircle },
];
const bottomItems = [
  // { title: 'Logs', href: '/dashboard/logs', icon: ScrollText },
  { title: 'Models', href: '/dashboard/models', icon: Boxes },
  { title: 'API Keys', href: '/dashboard/api-keys', icon: Key },
  { title: 'Billing', href: '/dashboard/billing', icon: CreditCard },
];

interface AppSidebarNavigationProps {
  isCollapsed: boolean;
}

export function AppSidebarNavigation({
  isCollapsed,
}: AppSidebarNavigationProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const { isMobile, openMobile, setOpenMobile } = useSidebar();

  return (
    <SidebarContent>
      <SidebarGroup className="flex flex-col gap-3">
        {!isCollapsed && (
          <SidebarGroupLabel className="text-lg font-bold">
            Menu
          </SidebarGroupLabel>
        )}
        <SidebarGroupContent>
          <SidebarMenu className="flex flex-col gap-3">
            {items.map((item) => (
              <SidebarMenuItemLink
                key={item.title}
                title={item.title}
                href={item.href}
                icon={item.icon}
                isCollapsed={isCollapsed}
                pathname={pathname}
                isMobile={isMobile}
                openMobile={openMobile}
                setOpenMobile={setOpenMobile}
              />
            ))}
            <StudioMenuCollapsible
              isCollapsed={isCollapsed}
              pathname={pathname}
              isMobile={isMobile}
              openMobile={openMobile}
              setOpenMobile={setOpenMobile}
            />
            {bottomItems.map((item) => (
              <SidebarMenuItemLink
                key={item.title}
                title={item.title}
                href={item.href}
                icon={item.icon}
                isCollapsed={isCollapsed}
                pathname={pathname}
                isMobile={isMobile}
                openMobile={openMobile}
                setOpenMobile={setOpenMobile}
              />
            ))}
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      <SidebarGroup className="flex flex-col gap-3">
        {!isCollapsed && (
          <SidebarGroupLabel className="text-lg font-bold">
            Showcase
          </SidebarGroupLabel>
        )}
        <SidebarGroupContent>
          <SidebarMenu className="flex flex-col gap-3">
            <SidebarMenuItem>
              <a
                href={NANO_BANANA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
                onClick={() => {
                  if (isMobile && openMobile) setOpenMobile(false);
                }}
              >
                <SidebarMenuButton
                  tooltip="Nano Banana"
                  className="hover:cursor-pointer px-5"
                >
                  <Banana />
                  {!isCollapsed && <span>Nano Banana</span>}
                </SidebarMenuButton>
              </a>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      <SidebarGroup className="flex flex-col gap-3">
        {!isCollapsed && (
          <SidebarGroupLabel className="text-lg font-bold">
            Community
          </SidebarGroupLabel>
        )}
        <SidebarGroupContent>
          <SidebarMenu className="flex flex-col gap-3">
            <SidebarMenuItem>
              <a
                href="http://discord.maiarouter.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="block"
                onClick={() => {
                  if (isMobile && openMobile) setOpenMobile(false);
                }}
              >
                <SidebarMenuButton
                  tooltip="Join Discord"
                  className="hover:cursor-pointer px-5"
                >
                  <MessageSquare />
                  {!isCollapsed && <span>Join Discord</span>}
                </SidebarMenuButton>
              </a>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
  );
}
